export default function getNavigationDetails(selectedPage, numberOfPages) {

    let navigation = {};
    navigation.selectedPage = selectedPage;

    let previous = {};
    previous.label = "Previous";
    previous.isVisible = selectedPage > 1 ? true : false;
    navigation.previous = previous;

    let next = {};
    next.label = "Next";
    next.isVisible = numberOfPages > selectedPage ? true : false;
    navigation.next = next;

    let visiblePages = [];

    visiblePages.push(selectedPage);
    let previousPage = selectedPage - 1;
    for (var i = 0; i < 5; i++) {
        if (previousPage > 0) {
            visiblePages.push(previousPage);
        }
        previousPage = previousPage - 1;
    }

    let currentNumberOfPages = 10 - visiblePages.length;
    let nextPage = selectedPage + 1;
    for (var i = 0; i < currentNumberOfPages; i++) {
        if (nextPage <= numberOfPages) {
            visiblePages.push(nextPage);
        }
        nextPage = nextPage + 1;
    }

    if (visiblePages.length < 10) {
        const minVal = Math.min(...visiblePages);
        let minValue = minVal - 1;
        let needPages = 10 - visiblePages.length;

        for (var i = 0; i < needPages; i++) {
            if (minValue > 0) {
                visiblePages.push(minValue);
            }
            minValue = minValue - 1;
        }
    }

    navigation.visiblePages = visiblePages.sort(compareNumbers);

    return navigation;
}

function compareNumbers(a, b) {
    return a - b;
}